import type { ExportRange } from '../../../renderer/src/export-range';
import { frameProgress } from '../../../renderer/src/timeline';
import { retimeFilmProgress } from '../domain/camera-plan';

/** Preserve each mark's opening, route or finish moment when film timing changes. */
export function retimeExportRange(range: ExportRange | null, previous: number, next: number): ExportRange | null {
  if (!range) return null;
  const retime = (frame: number) => Math.round(retimeFilmProgress(frameProgress(frame, previous * 30), previous, next) * (next * 30 - 1));
  return { inFrame: retime(range.inFrame), outFrame: retime(range.outFrame) };
}
